import pipe from '../utils/pipe.js';

const createModalStruct = function (modalOpts) {
    return {
        dom: {
            el: modalOpts.el,
            modalClose: modalOpts.el.querySelector('.modal-close'),
            modalContent: modalOpts.el.querySelector('.modal-content'),
            modalCurtain: modalOpts.el.querySelector('.modal-curtain')
        }
    };
};

const launchModal = function (modalStruct) {
    const {
        dom
    } = modalStruct;

    dom.el.classList.add('state-launch-transition');
    document.body.classList.add('state-modal-showing');

    setTimeout(() => {
        dom.el.classList.add('state-visible');

        setTimeout(() => {
            dom.el.classList.remove('state-launch-transition');
        }, 500);
    }, 10);

    const launchEvent = new Event('modalLaunch');
    document.body.dispatchEvent(launchEvent);
};

const closeModal = function (modalStruct) {
    window.history.pushState(null, null, '/');
    hideModal(modalStruct);
};

const hideModal = function (modalStruct) {
    const {
        dom
    } = modalStruct;
    dom.el.classList.add('state-launch-transition');
    setTimeout(() => {
        dom.el.classList.remove('state-visible');
        document.body.classList.remove('state-modal-showing');

        setTimeout(() => {
            dom.el.classList.remove('state-launch-transition');
        }, 500);
    }, 10);
};

const bindDomEvents = function (modalStruct) {
    const {
        dom
    } = modalStruct;

    dom.modalClose.onclick = () => { closeModal(modalStruct); };
    dom.modalCurtain.onclick = () => { closeModal(modalStruct); };

    return modalStruct;
};

const setContent = function (modalStruct, content) {
    const {
        dom
    } = modalStruct;

    dom.modalContent.innerHTML = content;

    return modalStruct;
};

const setLoading = function (modalStruct) {
    const {
        dom
    } = modalStruct;

    dom.el.classList.add('state-loading');
    setContent(modalStruct, '<div class="loading-spinner"></div>');

    return modalStruct;
};

const unsetLoading = function (modalStruct) {
    const {
        dom
    } = modalStruct;

    dom.el.classList.remove('state-loading');

    return modalStruct;
};

const createModalAPI = function (modalStruct) {
    return {
        launch (content = null) {
            if (typeof content === 'string') {
                unsetLoading(modalStruct);
                setContent(modalStruct, content);
            } else if (content && content.loading) {
                setLoading(modalStruct);
            }
            launchModal(modalStruct);
        },

        setContent (content) {
            setContent(modalStruct, content);
        },

        close () {
            closeModal(modalStruct);
        },

        hide () {
            hideModal(modalStruct);
        }
    };
};

const Modal = function (modalOpts) {
    const modalStruct = createModalStruct(modalOpts);

    pipe(modalStruct, [
        bindDomEvents
    ]);

    return createModalAPI(modalStruct);
};

export default Modal;



// WEBPACK FOOTER //
// ./assets/js/components/Modal.js